
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  ChangeStatutParams.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\ChangeStatutParams.ts

import {PS_Get_Buttons_Result } from "./PS_Get_Buttons_Result";
export class ChangeStatutParams {

  // int SupplierId
  public SupplierId: number=0;

  // int? documentId
  public documentId?: number=null;

  // int CurrentStatutId
  public CurrentStatutId: number=0;

  // int NewStatutId
  public NewStatutId: number=0;

  // string Comments
  public Comments?: string=null;

  // string MailModelCod
  public MailModelCod?: string=null;

  // int? WFMotifId
  public WFMotifId?: number=null;

  // PS_Get_Buttons_Result PressedButton
  public PressedButton: PS_Get_Buttons_Result=null;

  // bool EnvoiMailFournisseur
  public EnvoiMailFournisseur: boolean=false;

  // bool? CheckProfil
  public CheckProfil?: boolean=null;
}